// extracted by mini-css-extract-plugin
module.exports = {"poweredCon":"style_poweredCon__2curE","text":"style_text__3s0ys","poweredImg":"style_poweredImg__300jy"};